import { render, staticRenderFns } from "./StudentIds.vue?vue&type=template&id=95f722d0"
import script from "./StudentIds.vue?vue&type=script&lang=js"
export * from "./StudentIds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports